import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const PLAYER_STATS_URL = `${API_BASE_URL}/stats/players`;
const CAMPAIGN_DISCOVERY_URL = `${API_BASE_URL}/stats/campaign/discovery`;
const CAMPAIGN_DASHBOARD_URL = `${API_BASE_URL}/stats/campaign/dashboard`;
const BASKET_SETHP_URL = `${API_BASE_URL}/stats/basket/hp`;
const REWARD_SETRATE_URL = `${API_BASE_URL}/stats/reward/rate`;
const ITEM_SETCOUNT_URL = `${API_BASE_URL}/stats/item/count`;
const REWARD_SETCOUNT_URL = `${API_BASE_URL}/stats/reward/count`;
const BASKET_SETLOCATION_URL = `${API_BASE_URL}/stats/basket/location`;
const BASKET_CLOSE_URL = `${API_BASE_URL}/stats/basket/close`;
const BASKET_OPEN_URL = `${API_BASE_URL}/stats/basket/open`;
const CAMPAIGN_SETEVENTTIME_URL = `${API_BASE_URL}/stats/campaign/eventtime`;


/**
 * API에서 캠페인 목록을 가져옵니다.
 * @returns {Promise<Object>} 캠페인 목록 데이터를 담은 프로미스 객체
 */
export const getCampaignDiscovery = async () => {
  try {
    const response = await axios.get(CAMPAIGN_DISCOVERY_URL);
    if (response.data && response.data.processed && response.data.processed.code === 1) {
      return response.data.data;
    } else {
      const errorMessage = response.data && response.data.processed ? response.data.processed.message : 'API 요청에 실패했습니다.';
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error('캠페인 목록을 가져오는 중 오류 발생:', error);
    throw error;
  }
};

/**
 * API에서 캠페인 대시보드 데이터를 가져옵니다。
 * @param {number} campaignKey - 캠페인 키
 * @returns {Promise<Object>} 대시보드 데이터를 담은 프로미스 객체
 */
export const getCampaignDashboard = async (campaignKey) => {
  try {
    const response = await axios.post(CAMPAIGN_DASHBOARD_URL, {
      campaignKey,
    });

    if (response.data && response.data.processed && response.data.processed.code === 1) {
      return response.data.data;
    } else {
      const errorMessage = response.data && response.data.processed ? response.data.processed.message : 'API 요청에 실패했습니다.';
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error('캠페인 대시보드 정보를 가져오는 중 오류 발생:', error);
    throw error;
  }
};


/**
 * API에서 플레이어 통계를 가져옵니다.
 * @param {Object} params - API 요청 파라미터
 * @param {string} params.campaignFrom - 캠페인 시작일
 * @param {string} params.campaignTo - 캠페인 종료일
 * @param {string} params.dateFrom - 통계 조회 시작일
 * @param {string} params.dateTo - 통계 조회 종료일
 * @returns {Promise<Object>} 통계 데이터를 담은 프로미스 객체
 */
export const getPlayerStats = async ({ campaignFrom, campaignTo, dateFrom, dateTo }) => {
  try {
    const response = await axios.post(PLAYER_STATS_URL, {
      campaignFrom,
      campaignTo,
      dateFrom,
      dateTo,
    });

    if (response.data && response.data.processed && response.data.processed.code === 1) {
      return response.data.data;
    } else {
      const errorMessage = response.data && response.data.processed ? response.data.processed.message : 'API 요청에 실패했습니다.';
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error('플레이어 통계 정보를 가져오는 중 오류 발생:', error);
    throw error;
  }
};

/**
 * API를 통해 박 HP를 수정합니다.
 * @param {number} eventkey - 이벤트 키
 * @param {number} inputhp - 입력한 HP 값
 * @returns {Promise<Object>} 대시보드 데이터를 담은 프로미스 객체
 */
export const setBasketHP = async ({ eventkey, inputhp }) => {
    try {
        const response = await axios.post(BASKET_SETHP_URL, {
            eventkey,
            inputhp
        });

        if (response.data && response.data.processed && response.data.processed.code === 1) {
            return response.data.data;
        } else {
            const errorMessage = response.data && response.data.processed ? response.data.processed.message : 'API 요청에 실패했습니다.';
            throw new Error(errorMessage);
        }
    } catch (error) {
        console.error('값 변경 중 오류 발생:', error);
        throw error;
    }
};

/**
 * API를 통해 상품 수량을 수정합니다.
 * @param {number} eventkey - 이벤트 키
 * @param {number} itemkey - 상품 키
 * @param {number} inputitemcount - 입력한 수량
 * @returns {Promise<Object>}
 */
export const setItemCount = async ({ eventkey, itemkey, inputitemcount }) => {
    try {
        const response = await axios.post(ITEM_SETCOUNT_URL, {
            eventkey,
            itemkey,
            inputitemcount,
        });

        if (response.data && response.data.processed && response.data.processed.code === 1) {
            return response.data.data;
        } else {
            const errorMessage = response.data && response.data.processed ? response.data.processed.message : 'API 요청에 실패했습니다.';
            throw new Error(errorMessage);
        }
    } catch (error) {
        console.error('상품 수량 변경 중 오류 발생:', error);
        throw error;
    }
};

/**
 * API를 통해 박 확률을 수정합니다.
 * @param {number} eventkey - 이벤트 키
 * @param {number} inputbonusrate - 보물상자 나올 확률 (0.0 ~ 1.0)
 * @param {number} inputloserate - 꽝일 확률 (0.0 ~ 1.0)
 * @returns {Promise<Object>}
 */
export const setBasketRate = async ({ eventkey, inputbonusrate, inputloserate }) => {
    try {
        const response = await axios.post(REWARD_SETRATE_URL, {
            eventkey,
            inputbonusrate,
            inputloserate,
        });

        if (response.data && response.data.processed && response.data.processed.code === 1) {
            return response.data.data;
        } else {
            const errorMessage = response.data && response.data.processed ? response.data.processed.message : 'API 요청에 실패했습니다.';
            throw new Error(errorMessage);
        }
    } catch (error) {
        console.error('확률 변경 중 오류 발생:', error);
        throw error;
    }
};

/**
 * API를 통해 이벤트 일시를 수정합니다.
 * @param {number} eventkey - 이벤트 키
 * @param {number} campaignkey - 캠페인 키
 * @param {string} inputopendt - 오픈 일시 (YYYY-MM-DD HH:mm:ss)
 * @param {string} inputstartdt - 시작 일시
 * @param {string} inputenddt - 종료 일시
 * @param {string} inputclosedt - 클로즈 일시
 */
export const setCampaignEventTime = async ({ eventkey, campaignkey, inputopendt, inputstartdt, inputenddt, inputclosedt }) => {
    try {
        const response = await axios.post(CAMPAIGN_SETEVENTTIME_URL, {
            eventkey,
            campaignkey,
            inputopendt,
            inputstartdt,
            inputenddt,
            inputclosedt,
        });

        if (response.data && response.data.processed && response.data.processed.code === 1) {
            return response.data.data;
        } else {
            const errorMessage = response.data && response.data.processed ? response.data.processed.message : 'API 요청에 실패했습니다.';
            throw new Error(errorMessage);
        }
    } catch (error) {
        console.error('이벤트 일시 변경 중 오류 발생:', error);
        throw error;
    }
};

/**
 * API를 통해 박 위치(이벤트 위치)를 수정합니다.
 * @param {number} eventkey - 이벤트 키
 * @param {number} campaignkey - 캠페인 키
 * @param {number} inputlatitude - 입력한 위도 값
 * @param {number} inputlongitude - 입력한 경도 값
 * @param {number} inputdistance - 입력한 반경 값
 * @returns {Promise<Object>} 대시보드 데이터를 담은 프로미스 객체
 */
export const setBasketLocation = async ({ eventkey, campaignkey, inputlatitude , inputlongitude, inputdistance}) => {
    try {
        const response = await axios.post(BASKET_SETLOCATION_URL, {
            eventkey,
            campaignkey,
            inputlatitude,
            inputlongitude,
            inputdistance
        });

        if (response.data && response.data.processed && response.data.processed.code === 1) {
            return response.data.data;
        } else {
            const errorMessage = response.data && response.data.processed ? response.data.processed.message : 'API 요청에 실패했습니다.';
            throw new Error(errorMessage);
        }
    } catch (error) {
        console.error('값 변경 중 오류 발생:', error);
        throw error;
    }
};

/**
 * API를 통해 박을 즉시 터트립니다.
 * @param {number} eventkey - 이벤트 키
 * @returns {Promise<Object>} 대시보드 데이터를 담은 프로미스 객체
 */
export const setBasketClose = async ({ eventkey}) => {
    try {
        const response = await axios.post(BASKET_CLOSE_URL, {
            eventkey,
        });

        if (response.data && response.data.processed && response.data.processed.code === 1) {
            return response.data.data;
        } else {
            const errorMessage = response.data && response.data.processed ? response.data.processed.message : 'API 요청에 실패했습니다.';
            throw new Error(errorMessage);
        }
    } catch (error) {
        console.error('값 변경 중 오류 발생:', error);
        throw error;
    }
};

/**
 * API를 통해 박 타수를 즉시 초기화합니다.
 * @param {number} eventkey - 이벤트 키
 * @returns {Promise<Object>} 대시보드 데이터를 담은 프로미스 객체
 */
export const setBasketOpen = async ({ eventkey}) => {
    try {
        const response = await axios.post(BASKET_OPEN_URL, {
            eventkey,
        });

        if (response.data && response.data.processed && response.data.processed.code === 1) {
            return response.data.data;
        } else {
            const errorMessage = response.data && response.data.processed ? response.data.processed.message : 'API 요청에 실패했습니다.';
            throw new Error(errorMessage);
        }
    } catch (error) {
        console.error('값 변경 중 오류 발생:', error);
        throw error;
    }
};

export const setRewardCount = async ({ campaignkey, eventkey, rewardkey, count }) => {
    try {
        const response = await axios.post(REWARD_SETCOUNT_URL, { campaignkey, eventkey, rewardkey, count });
        if (response.data?.processed?.code === 1) return response.data.data;
        throw new Error(response.data?.processed?.message ?? 'API 요청에 실패했습니다.');
    } catch (error) {
        console.error('리워드 수량 변경 중 오류 발생:', error);
        throw error;
    }
};
